import { GridRenderCellParams } from "@mui/x-data-grid";

import { camelToCapitalisedWords } from "../../utils/string";
import RoundedSquareChip from "../atoms/RoundedSquareChip";

const StatusChip = (params: GridRenderCellParams) => {
  return (
    <RoundedSquareChip
      variant={params.value ? params.value : "outline"}
      label={camelToCapitalisedWords(params.value ?? "")}
    />
  );
};

export default StatusChip;
